import { ActivatedRoute } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';
import { WaHelperService } from 'world-archery-lib';
import { TextFilter, ComboStoreComponent } from 'src/app/common-page-components/stores/filters-store/filters-store';
import { HttpClient } from '@angular/common/http';
import { FiltersAbstractService } from 'src/app/common-page-components/classes/filters-abstract-service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "@angular/router";
export class FiltersServiceService extends FiltersAbstractService {
    constructor(http, route) {
        super();
        this.http = http;
        this.route = route;
        this.textFilter = new TextFilter('indoor-calendar-text-filter', undefined, undefined, 'search');
        this.yearCombo = new ComboStoreComponent('Year:', 'Year', 'indoorteamseriesyear', undefined, undefined, this.http, 'SERIES', [], [], true, 'year');
        this.filtersType = [
            this.textFilter.filterInfo,
            this.yearCombo.filterInfo
        ];
        this.generateDefaultValues();
    }
    /**
     * Method for generate the default values.
     *
     * @memberof FiltersServiceService
     */
    generateDefaultValues() {
        this.yearCombo.filterInfo.options.initial_state = true;
        this.yearCombo.requestData({ 'DisciplineId': 2, 'RBP': 'ALL' }, false).pipe(map(a => a.items), mergeMap(next => {
            let comboSeason = [];
            let index = next.findIndex(value => value.discipline === 2);
            comboSeason = next.filter(value => value.Year >= 2019 && value.Discipline === 2);
            let selected = comboSeason[index];
            if (this.route.snapshot.queryParams['year']) {
                index = comboSeason.findIndex(value => value.Year.toString() === this.route.snapshot.queryParams['year']);
                if (index > -1) {
                    selected = comboSeason[index];
                }
            }
            else {
                selected = WaHelperService.getComboSeasonItemByCurrentYear(comboSeason);
            }
            this.filtersType[1].options.options_subject.next(comboSeason);
            this.filtersType[1].options.options_selected_subject.next(selected);
            return of(next);
        })).subscribe();
    }
    /**
     *
     * @inheritdoc
     * @returns {Observable<any>}
     * @memberof FiltersServiceService
     */
    getDataStreamWithFilters() {
        return;
    }
}
FiltersServiceService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FiltersServiceService_Factory() { return new FiltersServiceService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.ActivatedRoute)); }, token: FiltersServiceService, providedIn: "root" });
